import React, { useState, useEffect } from "react";
import F1 from "../../Assessts/Images/Banners/Frame1.png";
import F2 from "../../Assessts/Images/Banners/Frame2.png";
import F3 from "../../Assessts/Images/Banners/Frame3.png";
import F4 from "../../Assessts/Images/Banners/Frame4.png";
import IOText from "../../ReUableComponents/ImageOntext";
import { useNavigate } from "react-router-dom";
const SlidingFrame = () => {
const navigate = useNavigate();
    const [Index, SetIndex] = useState(1);
    const Data = [
        {
            Image: F1,
            text: <div className="Text-MainDiv" >
                <button className="Website-Buttons" style={{ backgroundColor: "#F6F2EDB2", color: "#000000" }}>NSF INDIA </button>
                <div> “Developing Competency-Driven Learners with NCP”</div>
                <div className="mt-2 mb-2 Text-Content">Improving classroom learning by providing data-driven insights through assessments, dashboards, and feedback. </div>
                <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }} onClick={()=>navigate("/AboutUs")}>Learn About NCP</button>
            </div>,
        },
        {
            Image: F2,
            text: <div className="Text-MainDiv" >
                <button className="Website-Buttons" style={{ backgroundColor: "#F6F2EDB2", color: "#000000" }}>NSF INDIA </button>
                <div>“Building Strong Foundations with Competency-Driven Learning”</div>
                <div className="mt-2 mb-2 Text-Content ">Strengthening learning outcomes through curriculum-aligned, competency-based assessments for government schools. </div>
                <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }} onClick={()=>navigate("/AboutUs")}>Learn About NCP</button>
            </div>
        },
        {
            Image: F3,
            text: <div className="Text-MainDiv" >
                <button className="Website-Buttons" style={{ backgroundColor: "#F6F2EDB2", color: "#000000" }}>NSF INDIA </button>
                <div>“Empowering Deserving Students Through Access to Higher Education”</div>
                <div className="mt-2 mb-2 Text-Content">Enabling talented students to pursue higher education by removing financial barriers and supporting academic success.</div>
                <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }} onClick={()=>navigate("/AboutUs")}>Learn About NCP</button>
            </div>
        },
        {
            Image: F4,
            text: <div className="Text-MainDiv" >
                <button className="Website-Buttons" style={{ backgroundColor: "#F6F2EDB2", color: "#000000" }}>NSF INDIA </button>
                <div>“Enabling Academic Excellence Through Merit-Based Scholarships”</div>
                <div className="mt-2 mb-2 Text-Content">Creating pathways to professional education for deserving students through merit- and need-based scholarships. </div>
                <button className="Website-Buttons" style={{ backgroundColor: "#F7D670", color: "#000000" }} onClick={()=>navigate("/AboutUs")}>Learn About NCP</button>
            </div>
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            SetIndex((prev) => (prev + 1) % Data.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="mt-2" style={{ position: "relative" }}>
            <div>
                <IOText Image={Data[Index].Image} Alt="EMpower" Text={Data[Index].text} />
            </div>
            <div className="dflex gap-3 JCCenter All_Dots">
                {Data.map((_, i) => (
                    <button key={i} onClick={() => SetIndex(i)}
                        className={`DOts ${i === Index ? "Dots-Active" : ""}`} />
                ))}
            </div>
        </div>
    )
}
export default SlidingFrame;